/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUserInfo } from '../fn/users/get-user-info';
import { GetUserInfo$Params } from '../fn/users/get-user-info';
import { GetUserInfoResponse } from '../models/get-user-info-response';

@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserInfo()` */
  static readonly GetUserInfoPath = '/users/info';

  /**
   * Get user info.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserInfo$Response(params: GetUserInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserInfoResponse>> {
    return getUserInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * Get user info.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserInfo(params: GetUserInfo$Params, context?: HttpContext): Observable<GetUserInfoResponse> {
    return this.getUserInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserInfoResponse>): GetUserInfoResponse => r.body)
    );
  }

}
